import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from "./localization/en.json";
import se from "./localization/se.json";
import no from "./localization/no.json";
import fi from "./localization/fi.json";

export const resources = {
    en: {
        translation: en
    },
    se: {
        translation: se
    },
    no: {
        translation: no
    },
    fi: {
        translation: fi
    }
};


i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: 'en',
        returnNull: false,
        debug: true,
        interpolation: {
            escapeValue: false,
        }
    });


export default i18n;